import { render, staticRenderFns } from "./TemplateComp.vue?vue&type=template&id=657692cf&scoped=true"
import script from "./TemplateComp.vue?vue&type=script&lang=jsx"
export * from "./TemplateComp.vue?vue&type=script&lang=jsx"
import style0 from "./TemplateComp.vue?vue&type=style&index=0&id=657692cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657692cf",
  null
  
)

export default component.exports